module.exports = __webpack_public_path__ + "img/prize3.be39bbc3.png";